@if (svg$ | async; as svgPath) {
  <span class="svg-icon" [innerHtml]="svgPath | safeHtml"></span>
}
